<script>

export default {
  name: 'CallHelpBtn',
  props: {
    hasCalledHelp: {
      type: Boolean,
      required: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCallHelp () {
      this.$gtm.trackEvent({
        category: 'Call Help',
        action: 'call',
        label: '',
      });
      this.$emit('call-help');
    },
    onCancelHelp () {
      this.$gtm.trackEvent({
        category: 'Call Help',
        action: 'cancel',
        label: '',
      });
      this.$emit('cancel-help');
    },
  },
};
</script>

<template lang="pug">
div(v-if="!disabled")
  cta-style(:accent="!light", v-if="!hasCalledHelp", v-show="!disabled")
    button.call-help-btn.callbtn.f5.pa3.db.w-100(v-sound="'progress'", type="button", @click="onCallHelp", :disabled="disabled")
      icon.mr2.fill-green.w1.v-mid(name="help", v-if="!light")
      slot {{ $t('Call for help') }}
  link-style(v-else, v-show="!disabled")
    button.call-help-btn.cancelbtn.bg-cta-gray.relative.lh-copy.pa3.f5.db.w-100.h-100.flex.justify-center(type="button", @click="onCancelHelp")
      span.f7.underline.ttn {{ $t('Cancel Help') }}
</template>
